'use strict';

(function (angular) {
  angular.module('zp').controller('MixesController', mixesController);

  /**@ngInject */
  function mixesController($state, $timeout, mixesService, LoaderService) {
    var vm = this;

    vm.mixes = [];

    vm.openItem = openItem;

    /**Activate */
    (function () {
      loadMixes();
    })();

    function loadMixes() {
      return mixesService.getAll().then(function (response) {
        vm.mixes = response;
      });
    }

    function openItem(item) {
      $state.go('nav.mix-item', { alias: item.alias });
    }
  }
})(window.angular);